export default __webpack_public_path__ + "static/media/10_4_1.93843fef.png";